<template>
  <div>
    <v-dialog v-model="isModalOpen" max-width="630px" persistent>
      <v-toolbar dark color="primary" class="d-flex justify-center align-center">
        <v-toolbar-title class="body-heading-small">Remove From Wishlist</v-toolbar-title>
      </v-toolbar>
      <v-card tile class="modal-content-container">
        <v-card-title>
          <span class="body-heading-small ma-8">Are you sure you want to remove this item from your wish list?</span>
        </v-card-title>
        <v-card-text>
          <v-row class="px-3 justify-space-between">
              <v-btn color="secondary" class="modal-btn" @click="removeWish">Remove</v-btn>
              <v-btn color="secondary" class="modal-btn" outlined @click="toggleModal">Cancel</v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: "RemoveItemFromWishListModal",

    data() {
      return {};
    },

    props: {
      isModalOpen: {
        type: Boolean,
        required: true,
      },
      itemId: {
        required: true,
      },
    },

    methods: {
      toggleModal() {
        this.$emit("close-modal");
      },

      removeWish() {
        if (!this.$validator.isEmpty(this.itemId)) {
          this.$store.commit("setLoadingStatus", true);

          this.$http
            .delete(`/wishes/${this.itemId}`)
            .then((response) => {
              this.$store.commit("removeWish", this.itemId);

              this.$store.commit("setError", {
                message: "Removed the product from your wish list",
                type: "success",
              });
              this.$emit("close-modal");
              this.$store.commit("setLoadingStatus", false);
            })
            .catch(() => {
              this.$store.commit("setError", {
                message: "Failed to remove the product from your wish list",
                type: "error",
              });
              this.$emit("close-modal");
              this.$store.commit("setLoadingStatus", false);
            });
        } else {
          this.$store.commit("setError", {
            message: "Opps, something went wrong, please try again later.",
            type: "error",
          });
          this.$emit("close-modal");
          this.$store.commit("setLoadingStatus", false);
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/WishList/RemoveItemFromWishListModal.vue